module.exports = __webpack_public_path__ + "assets/img/096f-ws.svg";